module.exports = __webpack_public_path__ + "img/shop-canyin.33035736.png";